// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "https://api.dbusman.trangotechdevs.com";
const BASE_URL = "https://api.dbusmanapp.com";

// APIs design from Shaheer
const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "8065425d-80eb-4a69-91de-7e528fe08e28";

// const MAP_API_KEY = process.env.MAP_API_KEY;
const MAP_API_KEY = "AIzaSyDLAy1kA-3myJS-zwq3yfojTfko9Esfvo4";

export { API_URL, BASE_URL, INITIAL_TOKEN, MAP_API_KEY };
